import { AccountKind, FeatureFlagKey, SWIVL_STAFF_KINDS } from "@swivl-mono/types";
import { DEFAULT_AVATAR } from "@swivl-mono/ui";

import { isFeatureEnabled } from "../../Helpers/FeatureFlags/isFeatureEnabled";
import AccountModel from "../Account/AccountModel";

/* This is a helper class that will let us pull values
from the member object in the state without them being a mile long
*/
export class Member {
  static hasSeenStartShiftModal: boolean = false;

  static get account() {
    return AccountModel.state.account;
  }

  static get id() {
    return AccountModel.state.member?.id;
  }

  static get jwt() {
    return (AccountModel.state.member as any)?.jwt;
  }

  static get member() {
    return AccountModel.state.member;
  }

  static get displayName() {
    return AccountModel.state.member?.agentName || AccountModel.state.account?.firstName || "Agent";
  }
  static get avatarURL() {
    return AccountModel.state.member?.agentAvatarURL || AccountModel.state.account?.avatarURL || DEFAULT_AVATAR;
  }

  static get org() {
    return AccountModel.state.member?.org;
  }

  static get orgId() {
    return AccountModel.state.member!.org.id;
  }

  static get isInParentOrg() {
    return AccountModel.state.member?.org.isParent;
  }

  static get isInChildOrg() {
    return AccountModel.state.member?.org.parentId !== null;
  }

  static _canSeeOrg: { loaded: boolean; canSee: boolean } = { loaded: false, canSee: false };

  static get canSeeOrgSettings() {
    if (this._canSeeOrg.loaded) {
      return this._canSeeOrg.canSee;
    }
    this._canSeeOrg.loaded = true;
    this._canSeeOrg.canSee =
      AccountModel.state.member?.permissions.find((p) => {
        if (p.locations.orgId) {
          return true;
        }
      }) !== undefined;
    return this._canSeeOrg.canSee;
  }

  /**
   * Any Swivl employee. Covers SwivlStaff + SwivlAdmin. Use this for
   * staff-only UI: debug panels, internal-only settings pages, extra
   * columns in admin tables, etc.
   */
  static get isSwivlStaff() {
    return SWIVL_STAFF_KINDS.includes(AccountModel.state.account?.kind ?? AccountKind.Customer);
  }

  /**
   * Strictly the top tier — for genuinely admin-only operations
   * (promoting someone else to SwivlAdmin, billing, infra, account
   * deletion). If you need "any swivl employee," use isSwivlStaff.
   */
  static get isSwivlAdmin() {
    return AccountModel.state.account?.kind === AccountKind.SwivlAdmin;
  }

  static get isDev() {
    return AccountModel.state.account?.id === 1 ? true : false;
  }

  /**
   * The org's Snowy feature flag, for static (non-hook) callsites — the getter
   * `docs/snowy/guides/feature-flags.md` names as the model. It existed from
   * 2026-05-19 and was dropped by the single-helper refactor on 2026-06-21, the
   * same day the Twilio card's group lock started reading it; the field had been
   * silently hidden since (found on ENG-3468). React components use
   * `useFeatureFlag(FeatureFlagKey.Snowy)` instead.
   */
  static get isSnowyEnabled(): boolean {
    return isFeatureEnabled(FeatureFlagKey.Snowy);
  }

  static get twilioToken() {
    return AccountModel.state.member?.twilioToken;
  }

  static updateLastActive() {
    if (AccountModel.state.member && AccountModel.state.accountLoaded) {
    }
  }
}
